module.exports = __webpack_public_path__ + "dash_20_app_assets/img/notifications.a8763259.png";